// extracted by mini-css-extract-plugin
module.exports = {"articles":"resources_articles__TbfwM","background":"resources_background__9JzRv","sectionInner":"resources_sectionInner__lXLCX","subheadline":"resources_subheadline__FEBjn"};